const lang = {
  en: {
    Search: "search",
    gptSearchPlaceholder: "What would you like to watch today ?",
  },

  hindi: {
    Search: "खोज",
    gptSearchPlaceholder: "आज आप क्या देखना चाहेंगे?",
  },

  spanish: {
    Search: "buscar",
    gptSearchPlaceholder: "¿Qué te gustaría ver hoy?",
  },
};

export default lang;
